// This file is autogenerated. Any changes will be overwritten.

import useUID from '../../../hooks/useUID';

export const set = 'streamline';

export const name = 'search-analytics-solid';

export const Component = () => {
  const maskId = useUID();

  return (
    <>
      <defs>
        <mask id={maskId} fill='#000' stroke='#000' strokeLinecap='round'>
          <path fill='#fff' stroke='#fff' d='M0 0h18v18H0z' />
          <path
            fill='#fff'
            d='m.563 12.375 6.24-6.238a.711.711 0 0 1 1.004 0L9.64 7.973a.71.71 0 0 0 1.005 0l6.791-6.848'
          />
        </mask>
      </defs>
      <g stroke='currentColor' strokeLinecap='round'>
        <path fill='none' d='M17.5 4.76V1.152h-3.602' />
        <path d='m12.168 12.168 5.256 5.256M14.547 4.11 17.5 1.152m-17 11.4.648-.65' />
        <circle cx='7.5' cy='7.5' r='7' fill='currentColor' mask={`url(#${maskId})`} />
      </g>
    </>
  );
};

export const viewBox = '0 0 18 18';
